export default __webpack_public_path__ + "static/media/sprite.9e42eeb4.svg";